<script context="module"></script>

<script>export let scriptStr;
export let id;
export let nonce;
</script>

{@html `<script  data-id=${id}  nonce=${nonce || ""}>${scriptStr}</script>`}